<template>
    <ion-card
        button
        class="ion-text-center c-pagelink"
        :class="PageLinkColor"
        @click="changePage(path)"
    >
        <div class="c-pagelink__iconcontainer">
            <!-- <ion-icon :name="icon"></ion-icon> -->
            <!-- <span :class="icon"></span> -->
            <span :class="PageLinkIcon"></span>
        </div>
        <div class="c-pagelink__text" v-html="PageLinkLabel"></div>
    </ion-card>
</template>

<script>
import { page } from "@/mixins/page";

export default {
    mixins: [page],
    props: {
        path: {
            required: true
        },
        motiveclass: {
            type: Object,
            required: false,
            default: function() {
                return { ["-" + this.$route.path.split("/")[1]]: true };
            }
        },
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    mounted() {
        // console.log(this.title);
    },
    methods: {
        // changePage() {
        //     let path = this.path;
        //     if (
        //         typeof path === "object" &&
        //         "name" in this.path &&
        //         this.path.name === "services-unwetterwarnung" &&
        //         !("params" in this.path)
        //     ) {
        //         const contracts = this.$store.state.contracts;
        //         let foundContractId = false;
        //         for (let key in contracts) {
        //             if (
        //                 "Features" in contracts[key] &&
        //                 "Unwetter" in contracts[key].Features
        //             ) {
        //                 path.params = {};
        //                 path.params.contractId = key;
        //                 foundContractId = true;
        //                 break;
        //             }
        //         }
        //         if (foundContractId) {
        //             const motivesConfig = this.$store.state.motivesConfig;
        //             let selectedMotive = Object.values(
        //                 contracts[path.params.contractId].Motives
        //             )[0];
        //             let motivePath = "berater";
        //             for (let key in motivesConfig) {
        //                 if (motivesConfig[key].motive === selectedMotive) {
        //                     motivePath = motivesConfig[key].path;
        //                     break;
        //                 }
        //             }
        //             path.params.motive = motivePath;
        //             path.params.shouldPresentContractSwitcherModal = true;
        //         } else {
        //             this.$ionic.alertController
        //                 .create({
        //                     header: "Fehler",
        //                     message:
        //                         "Es wurde leider kein Vertrag gefunden, der dieses Feature unterstützt.",
        //                     buttons: ["OK"]
        //                 })
        //                 .then(a => a.present());
        //         }
        //     }
        //     this.$router.push(path);
        // }
    },
    computed: {
        PageLinkIcon() {
            let PageLinkConfig = this.$store.state.PageLinkConfig;
            if (PageLinkConfig[this.title] != undefined) {
                if (PageLinkConfig[this.title]["icon"] != undefined) {
                    return PageLinkConfig[this.title]["icon"];
                }
            }

            return "icon-pixelcloud";
        },
        PageLinkLabel() {
            let PageLinkConfig = this.$store.state.PageLinkConfig;
            if (PageLinkConfig[this.title] != undefined) {
                if (PageLinkConfig[this.title]["label"] != undefined) {
                    return PageLinkConfig[this.title]["label"];
                }
            }
            return this.title;
        },
        PageLinkColor() {
            let PageLinkConfig = this.$store.state.PageLinkConfig;
            if (PageLinkConfig[this.title] != undefined) {
                if (PageLinkConfig[this.title]["motive"] != undefined) {
                    return "-" + PageLinkConfig[this.title]["motive"];
                }
            }
            return this.motiveclass;
        }
    }
};
</script>

<style scoped lang="scss">
ion-card {
    // height: 100%;
}
.c-pagelink {
    padding: var(--gangl-padding-medium) var(--gangl-padding-xsmall);
    margin: 0;
    height: 100%;

    &__text {
        line-height: 1.25;
    }
    &__iconcontainer {
        margin-bottom: var(--gangl-padding-small);
    }

    [class^="icon-"],
    [class*=" icon-"] {
        font-size: xx-large;
    }

    &.-geld {
        background-color: var(--gangl-color-geld);
    }
    &.-gesundheit {
        background-color: var(--gangl-color-gesundheit);
    }
    &.-mobilitaet {
        background-color: var(--gangl-color-mobilitaet);
    }
    &.-wohnen {
        background-color: var(--gangl-color-wohnen);
    }
    &.-zukunft {
        background-color: var(--gangl-color-zukunft);
    }
    &.-berater {
        background-color: var(--gangl-color-berater);
    }
}
</style>
